var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Button } from './button';

/**
  @class a print button, wrapping a standard button and opening the URL provided in a new tab
  @extends Button
  @param {string} href - the URL to use
  @param {string} [icon='print'] the icon to render
  @param {string} [icon='action-print'] the class(es) to apply
*/
var PrintButton = function PrintButton(_ref) {
  var href = _ref.href,
      _ref$icon = _ref.icon,
      icon = _ref$icon === undefined ? 'print' : _ref$icon,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? 'action-print' : _ref$className,
      props = _objectWithoutProperties(_ref, ['href', 'icon', 'className']);

  return React.createElement(
    'a',
    { href: href, target: '_blank', rel: 'noopener noreferrer' },
    React.createElement(Button, _extends({ icon: icon, className: className }, props))
  );
};
export { PrintButton };